enum FiBicValue {
  NDEAFIHH = 'NDEAFIHH',
}

export default FiBicValue;
